import React, { useEffect, useState } from "react";
import {
	getDataFromJwt,
	isAdmin,
	replaceIdInUrl,
	toastMaker,
} from "../utils/utility";
import {
	EDIT_VOLUNTEER,
	LIST_MY_PROFILES,
	UPDATE_PROFILE,
	UPDATE_VOLUNTEER_PROFILE,
	VIEW_MY_PROFILE,
	VIEW_VOLUNTEER_PROFILE,
} from "../API_LIST";
import matrimonyInstance from "../utils/axios";
import { useLocation, useParams } from "react-router-dom";
import Popup from "../component/section/popup";

export default function ViewVolunteer() {
	const [userDetails, setUserDetails] = useState();
	const [modalIsOpen, setIsOpen] = useState(false);

	const { id } = useParams();
	const url = useLocation();
	const isEdit = false; //url?.pathname?.contains("edit");
	useEffect(() => {
		let url = replaceIdInUrl(VIEW_VOLUNTEER_PROFILE, id);
		matrimonyInstance.get(url).then((response) => {
			let objectIs = response.data;
			setUserDetails(objectIs);
		});
	}, []);

	function updateProfile(value) {
		let data = {
			profile_status: value,
		};
		let url = replaceIdInUrl(UPDATE_VOLUNTEER_PROFILE, id);
		matrimonyInstance.put(url, data).then((response) => {
			if (response.data) {
				setUserDetails(response.data.updatedVolunteerProfile);
				toastMaker(response.data.message);
			}
		});
	}

	let canApprove = isAdmin();

	const EnableorDisableProfile = (_className) => {
		return (
			<div className={_className}>
				{canApprove ? (
					userDetails?.status == "active" ? (
						<div className="d-flex gap-3">
							<button
								className=" btn-decline"
								onClick={() => updateProfile("inactive")}
							>
								Disable Volunteer
							</button>
						</div>
					) : (
						<div className="d-flex gap-3">
							<button
								className="btn-approve"
								onClick={() => updateProfile("active")}
							>
								Enable Volunteer
							</button>
						</div>
					)
				) : null}
			</div>
		);
	};

	const ProfileData = [
		{ key: "first_name", name: "First Name" },
		{ key: "last_name", name: "Last Name" },
		{ key: "email", name: "Email Address" },
		{ key: "mobile_number", name: "Mobile Number" },
	];

	function closeModal() {
		setIsOpen(false);
	}

	const handleChange = (e) => {
		const { value, pattern } = e.target;
		if (pattern && value) {
			let regex = new RegExp(pattern);
			let result = regex.test(value);
			if (!result) return;
		}
		setUserDetails((prev) => {
			return { ...prev, [e.target.name]: e.target.value };
		});
	};

	const editVolunteerData = () => {
		let data = {
			first_name: userDetails?.first_name,
			last_name: userDetails?.last_name,
			mobile_number: userDetails?.mobile_number,
		};

		console.log(data);

		const id = userDetails?.bat_volunteer_id;
		let url = replaceIdInUrl(EDIT_VOLUNTEER, id);
		matrimonyInstance
			.put(url, data)
			.then((response) => {
				closeModal();
				toastMaker("Volunteer Data Updated", "success");
			})
			.catch((error) => {
				console.log("error");
				toastMaker(error, "error");
			});
	};

	const editVolunteerContainer = userDetails && (
		<div className="create-volunteer">
			<h4 className="text-center mb-30">Edit Volunteer Data</h4>
			<div className="create-volunteer-responsive-width">
				<div className="form-group mb-20">
					<label className="mb-10">First Name</label>
					<input
						type="text"
						className="form-control"
						name="first_name"
						pattern="^[a-zA-Z ]+$"
						value={userDetails?.first_name}
						onChange={handleChange}
					/>
				</div>
				<div className="form-group mb-20">
					<label className="mb-10">First Name</label>
					<input
						type="text"
						className="form-control"
						name="last_name"
						pattern="^[a-zA-Z ]+$"
						value={userDetails?.last_name}
						onChange={handleChange}
					/>
				</div>
				<div className="form-group mb-20">
					<label className="mb-10">Mobile Number</label>
					<input
						type="tel"
						className="form-control"
						name="mobile_number"
						pattern="^\+?\d{1,15}$"
						value={userDetails?.mobile_number}
						maxLength={15}
						onChange={handleChange}
					/>
				</div>
				<button
					type="submit"
					className="btn mt-20 mb-25"
					onClick={editVolunteerData}
				>
					Submit
				</button>
			</div>
		</div>
	);

	return (
		<React.Fragment>
			<div className="dashboard-content">
				<div className="d-flex justify-content-center">
					{userDetails && (
						<div className="view-profile-card mb-20 mt-50">
							<div className="d-flex justify-content-between gap-3 align-items-center">
								<div className="d-flex gap-5 align-items-center">
									<h5 className="fw-700">
										{userDetails?.first_name} {userDetails?.last_name} Details
									</h5>
									{EnableorDisableProfile("is-desktop-approve-decline")}
								</div>
								<img
									src="../../assets/images/bat-img/profile-edit.svg"
									className="profile-edit-icon cursor-pointer"
									width={20}
									onClick={() => setIsOpen(true)}
								/>
							</div>
							{EnableorDisableProfile("is-responsive-approve-decline")}
							{ProfileData?.map((item, index) => (
								<p key={index}>
									<span className="key mr-10">{item?.name}:</span>
									<span>{userDetails[item?.key]}</span>
								</p>
							))}
						</div>
					)}
				</div>
			</div>
			<Popup
				modalIsOpen={modalIsOpen}
				closeModal={closeModal}
				html={editVolunteerContainer}
			/>
		</React.Fragment>
	);
}
